/**
 * @desc 平台SKU库存导出
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.stockSkuPlatform.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/platform/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
